export interface Iauditlog {
    auditId: Number;
    userID: string;
    userName: string;
    patientId: string;
    patientName: string;
    createdOn: Date;
    location: string;
    typeofAction: string;
    fromDate: string;
    toDate: string;
    moduleName: string;
    TotalSize: Number;
}

export class AuditLog {
    PatientID: number;
    EncounterId: string;
    UserID: string;
    ActionType: string;
    SPName: string;
    LocationId: string;
    TransactionStatus: string;
    PreviousValues: string;
    ChangedValues: string;
    InputParameters: string;
    Type: string;
}